// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar_header__Zck4g {
  background-color: #fdf8f8;
  padding: 15px 0;
  width: 100%;
}
.navbar_header__Zck4g .navbar_headerLogo__kcKER {
  max-width: 192px;
  width: 100%;
  display: block;
}
.navbar_header__Zck4g .navbar_headerLogo__kcKER img,
.navbar_header__Zck4g .navbar_headerLogo__kcKER svg {
  width: 100%;
  height: auto;
  object-fit: scale-down;
}
.navbar_header__Zck4g .navbar_headerRight__aYo4e {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
}
.navbar_header__Zck4g .navbar_headerRight__aYo4e .navbar_navItems__7cbnZ {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.navbar_header__Zck4g .navbar_headerRight__aYo4e .navbar_navItems__7cbnZ a {
  padding: 3px;
  font: var(--body-font-two);
  color: var(--text-color);
  text-transform: capitalize;
  transition: all 0.3s ease-in-out;
  border-bottom: 1px solid transparent;
}
.navbar_header__Zck4g .navbar_headerRight__aYo4e .navbar_navItems__7cbnZ a:hover, .navbar_header__Zck4g .navbar_headerRight__aYo4e .navbar_navItems__7cbnZ a.navbar_active__Lt7DW {
  border-color: var(--text-color);
}
.navbar_header__Zck4g .navbar_headerRight__aYo4e .navbar_headerBtns__3aPW3 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
}
.navbar_header__Zck4g .navbar_hamBurgerMenu__K0V1- {
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  background-color: #85a9b8;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
}
.navbar_header__Zck4g .navbar_hamBurgerMenu__K0V1- img,
.navbar_header__Zck4g .navbar_hamBurgerMenu__K0V1- svg {
  width: 100%;
  height: auto;
  object-fit: scale-down;
  filter: invert(1);
}
.navbar_header__Zck4g .navbar_drawerWrp__vZvK- .navbar_drawerContent__Cnyfl {
  width: 100%;
}

@media (max-width: 991px) {
  .navbar_header__Zck4g .navbar_headerRight__aYo4e {
    justify-content: flex-start;
    flex-direction: row-reverse;
    gap: 8px;
  }
  .navbar_header__Zck4g .navbar_headerRight__aYo4e .navbar_headerBtns__3aPW3 {
    gap: 8px;
  }
  .navbar_header__Zck4g .navbar_headerRight__aYo4e .navbar_headerBtns__3aPW3 a {
    padding: 6px 10px;
    font-size: 12px;
  }
  .navbar_navItems__7cbnZ {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 30px;
  }
  .navbar_navItems__7cbnZ li a {
    font-size: 18px;
  }
  .navbar_closeIcn__eBirD {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 35px;
    height: 35px;
    background-color: #85a9b8;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 10px;
  }
  .navbar_closeIcn__eBirD img,
  .navbar_closeIcn__eBirD svg {
    width: 100%;
    height: auto;
    object-fit: scale-down;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navbars/navbar.module.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,eAAA;EACA,WAAA;AACD;AACC;EACC,gBAAA;EACA,WAAA;EACA,cAAA;AACF;AACE;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;AACH;AAGC;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AADF;AAGE;EACC,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,YAAA;EACA,0BAAA;EACA,wBAAA;EACA,0BAAA;EACA,gCAAA;EACA,oCAAA;AADJ;AAGI;EAEC,+BAAA;AAFL;AAOE;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AALH;AASC;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AAPF;AASE;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;AAPH;AAYE;EACC,WAAA;AAVH;;AAeA;EAEE;IACC,2BAAA;IACA,2BAAA;IACA,QAAA;EAbD;EAcC;IACC,QAAA;EAZF;EAaE;IACC,iBAAA;IACA,eAAA;EAXH;EAiBD;IACC,aAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;EAfA;EAkBC;IACC,eAAA;EAhBF;EAqBD;IACC,kBAAA;IACA,WAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,YAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,aAAA;EAnBA;EAqBA;;IAEC,WAAA;IACA,YAAA;IACA,sBAAA;EAnBD;AACF","sourcesContent":[".header {\r\n\tbackground-color: #fdf8f8;\r\n\tpadding: 15px 0;\r\n\twidth: 100%;\r\n\r\n\t.headerLogo {\r\n\t\tmax-width: 192px;\r\n\t\twidth: 100%;\r\n\t\tdisplay: block;\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: auto;\r\n\t\t\tobject-fit: scale-down;\r\n\t\t}\r\n\t}\r\n\r\n\t.headerRight {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: flex-end;\r\n\t\talign-items: center;\r\n\t\tgap: 15px;\r\n\r\n\t\t.navItems {\r\n\t\t\tflex: 1;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: center;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\ta {\r\n\t\t\t\tpadding: 3px;\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tcolor: var(--text-color);\r\n\t\t\t\ttext-transform: capitalize;\r\n\t\t\t\ttransition: all 0.3s ease-in-out;\r\n\t\t\t\tborder-bottom: 1px solid transparent;\r\n\r\n\t\t\t\t&:hover,\r\n\t\t\t\t&.active {\r\n\t\t\t\t\tborder-color: var(--text-color);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.headerBtns {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: flex-end;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 15px;\r\n\t\t}\r\n\t}\r\n\r\n\t.hamBurgerMenu {\r\n\t\tflex-shrink: 0;\r\n\t\twidth: 35px;\r\n\t\theight: 35px;\r\n\t\tbackground-color: #85a9b8;\r\n\t\tcolor: white;\r\n\t\tborder-radius: 50%;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tcursor: pointer;\r\n\t\tpadding: 8px;\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: auto;\r\n\t\t\tobject-fit: scale-down;\r\n\t\t\tfilter: invert(1);\r\n\t\t}\r\n\t}\r\n\r\n\t.drawerWrp {\r\n\t\t.drawerContent {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.header {\r\n\t\t.headerRight {\r\n\t\t\tjustify-content: flex-start;\r\n\t\t\tflex-direction: row-reverse;\r\n\t\t\tgap: 8px;\r\n\t\t\t.headerBtns {\r\n\t\t\t\tgap: 8px;\r\n\t\t\t\ta {\r\n\t\t\t\t\tpadding: 6px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.navItems {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 15px;\r\n\t\tmargin-top: 30px;\r\n\r\n\t\tli {\r\n\t\t\ta {\r\n\t\t\t\tfont-size: 18px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.closeIcn {\r\n\t\tposition: absolute;\r\n\t\tright: 10px;\r\n\t\ttop: 10px;\r\n\t\twidth: 35px;\r\n\t\theight: 35px;\r\n\t\tbackground-color: #85a9b8;\r\n\t\tcolor: white;\r\n\t\tborder-radius: 50%;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tcursor: pointer;\r\n\t\tpadding: 10px;\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: auto;\r\n\t\t\tobject-fit: scale-down;\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `navbar_header__Zck4g`,
	"headerLogo": `navbar_headerLogo__kcKER`,
	"headerRight": `navbar_headerRight__aYo4e`,
	"navItems": `navbar_navItems__7cbnZ`,
	"active": `navbar_active__Lt7DW`,
	"headerBtns": `navbar_headerBtns__3aPW3`,
	"hamBurgerMenu": `navbar_hamBurgerMenu__K0V1-`,
	"drawerWrp": `navbar_drawerWrp__vZvK-`,
	"drawerContent": `navbar_drawerContent__Cnyfl`,
	"closeIcn": `navbar_closeIcn__eBirD`
};
export default ___CSS_LOADER_EXPORT___;
